(function () {
  if (window.LJEventMapLoaded) return;
  window.LJEventMapLoaded = true;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatMoney(value, currency) {
    const amount = Number(value || 0);
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (_) {
      return "$" + amount.toFixed(amount % 1 === 0 ? 0 : 2);
    }
  }

  function formatDate(event) {
    const date = new Date((event.date || "") + "T" + (event.time || "00:00") + ":00");
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    }).format(date);
  }

  function eventPrice(event, includeLabel) {
    const value = event.checkoutPrice != null ? event.checkoutPrice : event.price;
    const formatted = formatMoney(value, event.currency);
    return includeLabel ? formatted + " total" : formatted;
  }

  function stateName(region) {
    const names = { FL: "Florida", KS: "Kansas" };
    return names[region] || region || "";
  }

  function cityName(event) {
    return String(event.city || "").split(",")[0].trim();
  }

  function marketRegion(event) {
    const city = cityName(event).toLowerCase();
    if (event.addressRegion === "KS") return "Wichita area";
    if (["orlando", "kissimmee", "winter garden", "winter park", "longwood", "sanford", "ocoee"].includes(city)) return "Central Florida";
    if (["fort myers", "naples", "bonita springs", "cape coral"].includes(city)) return "Southwest Florida";
    if (["melbourne", "cocoa", "titusville"].includes(city)) return "Space Coast";
    return event.regionLabel || stateName(event.addressRegion) || "Workshop area";
  }

  function uniqueValues(events, getter) {
    return Array.from(new Set(events.map(getter).filter(Boolean)));
  }

  function clusterName(events, zoom) {
    const states = uniqueValues(events, function (event) { return event.addressRegion || ""; });
    const regions = uniqueValues(events, marketRegion);
    const cities = uniqueValues(events, cityName);
    if (zoom <= 6) return states.length === 1 ? stateName(states[0]) + " workshops" : "Workshop states";
    if (zoom <= 8) {
      if (regions.length === 1) return regions[0] + " workshops";
      return states.length === 1 ? stateName(states[0]) + " regions" : "Workshop regions";
    }
    if (zoom <= 10) {
      if (cities.length === 1) return cities[0] + " workshops";
      return regions.length === 1 ? regions[0] + " cities" : "Nearby cities";
    }
    return cities.length === 1 ? cities[0] + " venues" : "Nearby venues";
  }

  function markerName(event, zoom) {
    if (zoom <= 6) return stateName(event.addressRegion) + " workshop";
    if (zoom <= 8) return marketRegion(event) + " workshop";
    if (zoom <= 10) return cityName(event) + " workshop";
    return event.venue || event.city || "Workshop";
  }

  function markerIcon(event, zoom) {
    const status = zoom >= 11
      ? (event.isComingSoon ? "Soon" : event.isSoldOut ? "Sold out" : eventPrice(event, false))
      : "1";
    return L.divIcon({
      className: "lj-map-pin-label",
      html: '<div class="lj-map-pin' + (event.isSoldOut ? " is-sold" : "") + (event.isComingSoon ? " is-coming-soon" : "") + '"><div class="lj-map-pin-dot">' + escapeHtml(status) + '</div><span>' + escapeHtml(markerName(event, zoom)) + '</span></div>',
      iconSize: [180, 58],
      iconAnchor: [90, 29]
    });
  }

  function renderCard(event) {
    var detailsUrl = event.siteUrl || event.url;
    return [
      '<article class="lj-event-card" data-event-id="' + escapeHtml(event.id) + '">',
      event.image ? '<a class="lj-event-card-media" href="' + escapeHtml(detailsUrl) + '"><img src="' + escapeHtml(event.image) + '" alt="' + escapeHtml(event.title) + ' workshop" loading="lazy"></a>' : "",
      '<div class="lj-event-card-body">',
      '<p class="lj-event-meta">' + escapeHtml(formatDate(event)) + ' · ' + escapeHtml(event.city || "") + '</p>',
      '<h3><a class="lj-event-card-title" href="' + escapeHtml(detailsUrl) + '">' + escapeHtml(event.title) + '</a></h3>',
      '<p>' + escapeHtml(event.venue || "") + (event.address ? '<br>' + escapeHtml(event.address) : "") + '</p>',
      '<div class="lj-event-card-foot">',
      '<span>' + (event.isSoldOut ? "Sold out" : escapeHtml(eventPrice(event, true))) + '</span>',
      '<a class="lj-event-card-cta" href="' + escapeHtml(detailsUrl) + '">Class details</a>',
      '</div>',
      '</div>',
      '</article>'
    ].join("");
  }

  function renderCards(container, events, emptyMessage) {
    const list = container.querySelector("[data-lj-event-list]");
    if (!list) return;
    const message = emptyMessage
      ? '<p class="lj-event-empty">' + escapeHtml(emptyMessage) + '</p>'
      : "";
    list.innerHTML = events.length
      ? message + events.map(renderCard).join("")
      : '<p class="lj-event-empty">No public Bonsai & Cheers workshops are published right now.</p>';
  }

  function initMap(container, data) {
    const mapEl = container.querySelector("[data-lj-event-map-canvas]");
    if (!mapEl || typeof L === "undefined") return;

    const events = (data.events || []).filter(function (event) {
      return Number.isFinite(Number(event.latitude)) && Number.isFinite(Number(event.longitude));
    });
    if (!events.length) return;

    const mapEvents = events;
    const spansStates = new Set(events.map(function (event) {
      return event.addressRegion || "";
    })).size > 1;

    const map = L.map(mapEl, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    }).setView(spansStates ? [33.8, -88.8] : [27.9, -81.2], spansStates ? 5 : 6);

    L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}", {
      attribution: "Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ",
      maxZoom: 16,
      minZoom: spansStates ? 4 : 6
    }).addTo(map);

    const group = L.markerClusterGroup({
      maxClusterRadius: function (zoom) {
        if (zoom <= 7) return 120;
        if (zoom <= 9) return 60;
        return 30;
      },
      showCoverageOnHover: false,
      spiderfyOnMaxZoom: true,
      iconCreateFunction: function (cluster) {
        const childEvents = cluster.getAllChildMarkers().map(function (marker) {
          return marker._ljEvent;
        }).filter(Boolean);
        return L.divIcon({
          className: "lj-map-pin-label",
          html: '<div class="lj-map-cluster"><div class="lj-map-cluster-count">' + childEvents.length + '</div><span>' + escapeHtml(clusterName(childEvents, map.getZoom())) + '</span></div>',
          iconSize: [180, 62],
          iconAnchor: [90, 31]
        });
      }
    });

    const markers = [];
    mapEvents.forEach(function (event) {
      const marker = L.marker([Number(event.latitude), Number(event.longitude)], {
        icon: markerIcon(event, map.getZoom())
      });
      marker._ljEvent = event;
      var detailsUrl = event.siteUrl || event.url;
      marker.bindPopup([
        '<strong>' + escapeHtml(event.title) + '</strong>',
        '<p class="lj-map-popup-meta">' + escapeHtml(formatDate(event)) + '<br>' + escapeHtml(event.venue || "") + '</p>',
        '<a class="lj-map-popup-button" href="' + escapeHtml(detailsUrl) + '">Class details</a>'
      ].join(""));
      marker.on("click", function () {
        const zoom = map.getZoom();
        if (zoom >= 11) return;
        marker.closePopup();
        const nextZoom = zoom <= 6 ? 7 : zoom <= 8 ? 9 : 11;
        map.setView(marker.getLatLng(), nextZoom, { animate: true });
      });
      group.addLayer(marker);
      markers.push(marker);
    });

    map.addLayer(group);
    if (mapEvents.length === 1) {
      map.setView([Number(mapEvents[0].latitude), Number(mapEvents[0].longitude)], 10);
    } else if (mapEvents.length > 1) {
      map.fitBounds(group.getBounds().pad(0.18));
      map.setZoom(Math.max(map.getMinZoom(), map.getZoom() - 1));
    }
    function refreshMapLabels() {
      const zoom = map.getZoom();
      markers.forEach(function (marker) {
        marker.setIcon(markerIcon(marker._ljEvent, zoom));
      });
      group.refreshClusters();
    }
    group.on("spiderfied", function (event) {
      event.markers.forEach(function (marker) {
        marker.setIcon(markerIcon(marker._ljEvent, 11));
      });
    });
    group.on("unspiderfied", refreshMapLabels);
    refreshMapLabels();
    map.on("zoomend", refreshMapLabels);
  }

  function initSection(container) {
    const src = container.getAttribute("data-events-src");
    const requestedState = new URLSearchParams(window.location.search).get("state");
    const stateFilter = requestedState ? requestedState.trim().toUpperCase() : "";
    const cityFilters = (container.getAttribute("data-event-city") || "")
      .split(",")
      .map(function (city) {
        return city.trim().toLowerCase();
      })
      .filter(Boolean);
    if (!src) return;

    fetch(src, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Could not load Eventbrite events.");
        return response.json();
      })
      .then(function (data) {
        let localImages = {};
        const localImagesEl = container.querySelector("[data-lj-event-images]");
        if (localImagesEl) {
          try { localImages = JSON.parse(localImagesEl.textContent); } catch (error) { localImages = {}; }
        }
        const allEvents = (data.events || []).filter(function (event) {
          return event.url && !event.is_cancelled && Date.parse(event.endDateTime || event.startDateTime) > Date.now();
        }).map(function (event) {
          if (localImages[event.id]) event.image = localImages[event.id];
          return event;
        });
        let events = allEvents.filter(function (event) {
          if (stateFilter && event.addressRegion !== stateFilter) return false;
          if (!cityFilters.length) return true;
          const city = String(event.city || "").split(",")[0].trim().toLowerCase();
          return cityFilters.includes(city);
        });
        let emptyMessage = "";
        if ((cityFilters.length || stateFilter) && !events.length) {
          emptyMessage = "No workshop is currently published for this area. View all classes for the nearest available date.";
        }
        renderCards(container, events, emptyMessage);
        initMap(container, {
          events: events,
          showExpansionMarkets: !cityFilters.length
        });
        const generated = container.querySelector("[data-lj-event-generated]");
        if (generated && data.generatedAt) {
          generated.textContent = "Updated from Eventbrite " + new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit"
          }).format(new Date(data.generatedAt));
        }
      })
      .catch(function () {
        container.classList.add("is-fallback");
      });
  }

  function initAll() {
    document.querySelectorAll("[data-lj-event-map-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();
